// Mod data organized by game
// Add your mods here - each mod needs: id, name, description, version, curseforgeUrl, and optional thumbnail

export const games = [
  {
    id: 'hytale',
    name: 'Hytale',
    description: 'Mods for Hytale',
    thumbnail: '/images/games/hytale.webp',
  },
  // Add more games here as needed:
  // {
  //   id: 'minecraft',
  //   name: 'Minecraft',
  //   description: 'Mods for Minecraft',
  //   thumbnail: '/images/games/minecraft.png',
  // },
];

export const mods = {
  hytale: [
    {
      id: 'p2p-1',
      name: 'Player 2 Player Teleport',
      shortDescription: 'Send teleport requests to other players on your server.',
      fullDescription: `
A simple teleport request system that allows players to teleport to each other with consent.

Commands:
- /tpa {playerName} - Send a teleport request to another player
- /tpaccept - Accept an incoming teleport request
- /tpdeny - Deny an incoming teleport request

Perfect for multiplayer servers where you want players to be able to meet up easily without giving everyone free teleport access.
      `,
      version: '0.0.4',
      gameVersion: 'Early Access',
      curseforgeUrl: 'https://www.curseforge.com/hytale/mods/player-2-player-teleports',
      thumbnail: '/images/mods/hytale/p2p-1.webp',
      screenshots: [],
      tags: ['multiplayer', 'teleport', 'utility'],
    },
    // Add more Hytale mods here
  ],
  // Add mods for other games here:
  // minecraft: [
  //   { ... }
  // ],
};

// Helper function to get a game by ID
export const getGameById = (gameId) => {
  return games.find(game => game.id === gameId);
};

// Helper function to get mods for a game
export const getModsForGame = (gameId) => {
  return mods[gameId] || [];
};

// Helper function to get a specific mod
export const getModById = (gameId, modId) => {
  const gameMods = mods[gameId] || [];
  return gameMods.find(mod => mod.id === modId);
};
